export const NEXT_TEXT = "Next";
export const BACK_TEXT = "Back";
export const FINISH_TEXT = "Finish";

export enum StepsType {
  NUMBERS = "numbers",
  GALLERY = "gallery"
}

export enum StepsDotAriaCurrent {
  PAGE = "page",
  STEP = "step",
  LOCATION = "location",
  DATE = "date",
  TIME = "time"
}

export enum StepsColor {
  PRIMARY = "primary",
  ON_PRIMARY_COLOR = "on-primary-color",
  ON_INVERTED_BACKGROUND = "on-inverted-background"
}
